import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import { noop } from 'lodash';
import { OptionFilter } from '@periscopes/general/filters';
import React from 'react';

import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DATA_SENSITIVITY_LABELS, DataSensitivityLevelId } from '@sonar-software/sonar-core';

const options = enumNumericValues(DataSensitivityLevelId).map((level: DataSensitivityLevelId) => ({
	label: DATA_SENSITIVITY_LABELS[ level ],
	value: level
}));

export interface DataSensitivityFormSelectorProps {
	id?: string;
	mode?: 'multiple' | 'tags'
	onChange?: (value: DataSensitivityLevelId) => void;
	placeholder?: string;
	value?: DataSensitivityLevelId;
}

export const DataSensitivityFormSelector: React.FC<DataSensitivityFormSelectorProps> = ({
	onChange = noop,
	placeholder,
	...props
}) =>
	<OptionFilter
		{ ...props }
		onChange={ onChange }
		options={ options }
		placeholder={ placeholder ?? COPY_GENERIC.SELECT(COPY_SPECIFIC.DATA_SENSITIVITY) } />;
